import { Autocomplete, Avatar, Box, InputAdornment, TextField, Typography } from '@mui/material';
import React from 'react';
import { Search as SearchIcon } from '@mui/icons-material';

const AutocompleteStores = ({
  dataStores = [],
  loadingStores = false,
  debounceRef,
  fetchDataStores,
  hasSearchIcon = true,
  textColor = 'white', // 👈 'white' por padrão (NavBar), mude para 'black' no modal
  sx = {},
}) => {
  const isLight = textColor === 'black';

  return (
    <Autocomplete
      options={Array.isArray(dataStores) ? dataStores : []}
      loading={loadingStores}
      filterOptions={(options) => options}
      getOptionLabel={(option) => option.name || ''}
      noOptionsText="Nenhuma loja encontrada"
      loadingText="Buscando..."
      onInputChange={(_, value) => {
        if (debounceRef?.current) {
          clearTimeout(debounceRef.current);
        }

        if (!value.trim()) {
          return;
        }

        if (debounceRef) {
          debounceRef.current = setTimeout(() => {
            fetchDataStores(value.trim(), 5);
          }, 450);
        }
      }}
      onChange={(_, value) => {
        if (value) {
          window.open(`/cupom-desconto-${value.slug}`, '_blank', 'noopener,noreferrer');
        }
      }}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;
        return (
          <Box
            component="li"
            key={key}
            {...otherProps}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              padding: '8px 12px',
            }}
          >
            <Avatar
              src={`https://cdn.meucupom.com/store_logos/${option.slug}.png`}
              alt={option.name}
              variant="rounded"
              sx={{ backgroundColor: 'transparent' }}
              imgProps={{
                style: {
                  objectFit: 'contain',
                  width: '100%',
                  height: '100%',
                },
              }}
            />
            <Typography variant="body2">
              {option.name}
              {!!option.cashbackOn && Number(option.cashbackPercentage) > 0 && (
                <Typography component="span" variant="body2" sx={{ fontWeight: 'bold', color: '#348AC7', ml: 0.5 }}>
                  +{+option.cashbackPercentage}% cashback
                </Typography>
              )}
            </Typography>
          </Box>
        );
      }}
      sx={{
        '& .MuiAutocomplete-popupIndicator': { color: textColor },
        '& .MuiAutocomplete-clearIndicator': { color: textColor },
        ...sx,
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Digite sua loja aqui!"
          sx={{
            display: 'block',
            backgroundColor: 'transparent',
            borderRadius: '8px',
            width: { xs: '100%', sm: '242px' },
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              color: textColor, // 👈 Aplica a cor do texto digitado
              '& fieldset': {
                borderColor: isLight ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.4)', // Borda normal
              },
              '&:hover fieldset': {
                borderColor: isLight ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.8)', // Borda hover
              },
              '&.Mui-focused fieldset': {
                borderColor: isLight ? '#1976d2' : 'white', // Borda ao focar
              },
            },
            '& .MuiInputBase-input::placeholder': {
              color: isLight ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.7)', // Placeholder
              opacity: 1,
            },
            '& .MuiInputBase-input': {
              padding: '10px 12px',
            },
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                {hasSearchIcon && (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: textColor, fontSize: 22 }} />
                  </InputAdornment>
                )}
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default AutocompleteStores;